import * as React from 'react';

import './note.scss';

type NoteProps = {
    description?: string | JSX.Element;
};

export const Note = ({ description }: NoteProps): JSX.Element => (
    <div className="note">
        <p className="note__description">{description}</p>
    </div>
);
